export default function HoldIcon({
  color = "#667085",
  fill = "none",
  width = 28,
  height = 28,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer circle */}
      <circle
        cx="10"
        cy="10"
        r="9"
        stroke={color}
        strokeWidth="1.5"
      />

      {/* Pause bars */}
      <line
        x1="8"
        y1="6"
        x2="8"
        y2="14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="6"
        x2="12"
        y2="14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
